<template>
  <div>
    <p v-if="description" class="text-muted pb-2">{{ description }}</p>
    <router-link to="/group/add">
      <b-button class="spnod-admin__form--button mb-2" size="sm">Create a Group</b-button>
    </router-link>
    <AdminTableContainer
      :headers="headers"
      :users="localUsers"
      :options="options"/>
  </div>
</template>

<script>
import AdminTableContainer from '../../components/AdminTableContainer'
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'GroupMgmt',
  components: { AdminTableContainer },
  data() {
    return {
      headers: ['name', 'users', 'description', 'userCount'],
      localUsers: {},
      options: {
        sortable: true,
        actions: ['groupEdit']
      },
      description: null
    }
  },
  computed: {
    ...mapGetters(['groups', 'getMyInfo'])
  },
  methods: {
    ...mapActions(['getGroups', 'getDescription'])
  },
  mounted: async function() {
    if (!this.getMyInfo.hasRoles) {
      const obj = await this.getDescription()
      this.description = obj.group
    }
    await this.getGroups({})
    this.localUsers = this.groups
  },
  watch: {
    groups: {
      handler: function () {
        this.localUsers = this.groups
      },
      deep: true
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/app/Pages/GroupMgmt/GroupMgmt.vue?ef5668dc